const state = {
  url: {
    // USED FOR CREATING DOWNLOAD LINKS
    //server: "http://77.135.171.68", // SRV DEV
    server: "https://app.dmcware.com", // SRV PROD

    // USED TO INTERROGATE DATABASE
    db: {
      //creation: "http://127.0.0.1:3000", // LOCAL
      //creation: "http://77.135.171.68:3000", // SRV DEV
      creation: "https://app.dmcware.com:3000", // SRV PROD
      player: "https://app.dmcware.com:3000", // SRV PROD
    },

    // USED TO EXPLORE, READ, WRITE FILES
    explorer: {
      //creation: "http://127.0.0.1:4000", // LOCAL
      //creation: "http://77.135.171.68:4000", // SRV DEV
      creation: "https://app.dmcware.com:4000", // SRV PROD
      player: "http://127.0.0.1:4000", // SRV PROD
    },

    // USED TO NOTIFY USERS (NORMALLY ON DB EXPRESS SERVER)
    mailer: {
      //creation: "http://127.0.0.1:3000", // LOCAL
      //creation: "http://77.135.171.68:3000",  // SRV DEV
      creation: "https://app.dmcware.com:3000", // SRV PROD
      player: "https://app.dmcware.com:3000", // SRV PROD
    },

    // USED TO CONNECT ON MQTT AND RECEIVED MSGS
    mqtt: {
      //ip: "192.168.140.221", // SRV DEV
      ip: "77.135.171.67", // SRV PROD
      port: "1883",
      username: "usr_test",
      password: "pwd_test",
    },
  },
  dirs: {
    app: "../app/",
    mediacenter: "../app/mediacenter/",
    root: "./",
  },
  prefs: {
    bottomNavbar: false,
    darkTheme: localStorage.darkTheme ? localStorage.darkTheme : "true",
    iconSize: localStorage.iconSize ? parseInt(localStorage.iconSize, 10) : 25,
    isMinimized: localStorage.isMinimized ? localStorage.isMinimized : "true",
    lang: localStorage.lang ? localStorage.lang : "fr",
  },
  system: {
    defaultSchedule: "default.png",
    isCreation: true, // SWITCH BETWEEN TRUE OR FALSE TO MAKE PLAYER OR CREATION
    license: "",
    position: [],
    resolution: [],
    screensaverMode: false,
    statsEnable: true,
  },
};

const mutations = {
  SETAPPDIR: function (state, dir) {
    state.dirs.app = dir;
  },
  SETBOTTOMBAR: function (state, isActive) {
    state.prefs.bottomNavbar = isActive;
  },
  SETDARKTHEME: function (state, isDark) {
    state.prefs.darkTheme = isDark;
  },
  SETICONSIZE: function (state, size) {
    state.prefs.iconSize = size;
  },
  SETLICENSE: function (state, lic) {
    state.system.license = lic;
  },
  SETLANG: function (state, lang) {
    state.system.lang = lang;
  },
  SETNAVBAR: function (state, isActive) {
    state.prefs.isMinimized = isActive;
  },
  SETPOSITION: function (state, pos) {
    state.system.position = pos;
  },
  SETRESOLUTION: function (state, res) {
    state.system.resolution = res;
  },
  SETSCREENSAVERMODE: function (state, res) {
    state.system.screensaverMode = res;
  },
  SETSTATSENABLE: function (state, enable) {
    state.system.statsEnable = enable;
  },
  TOGGLEBOTTOMBAR: function (state) {
    state.prefs.bottomNavbar = !state.prefs.bottomNavbar;
  },
  TOGGLEDARKTHEME: function (state) {
    state.prefs.darkTheme = !state.prefs.darkTheme;
  },
  TOGGLENAVBAR: function (state) {
    if (state.prefs.isMinimized === "true") {
      state.prefs.isMinimized = "false";
    } else {
      state.prefs.isMinimized = "true";
    }
  },
};

const actions = {
  setAppDir: ({ commit }, dir) => {
    commit("SETAPPDIR", dir);
  },
  setBottomBar: ({ commit }, isActive) => {
    commit("SETBOTTOMBAR", isActive);
  },
  setDarkTheme: ({ commit }, isDark) => {
    commit("SETDARKTHEME", isDark);
  },
  setIconSize: ({ commit }, size) => {
    commit("SETICONSIZE", size);
  },
  setLang: ({ commit }, lang) => {
    commit("SETLANG", lang);
  },
  setLicense: ({ commit }, lic) => {
    commit("SETLICENSE", lic);
  },
  setNavbar: ({ commit }, isActive) => {
    commit("SETNAVBAR", isActive);
  },
  setPosition: ({ commit }, res) => {
    commit("SETPOSITION", res);
  },
  setResolution: ({ commit }, res) => {
    commit("SETRESOLUTION", res);
  },
  setScreensaverMode: ({ commit }, res) => {
    commit("SETSCREENSAVERMODE", res);
  },
  setStatsEnable: ({ commit }, res) => {
    commit("SETSTATSENABLE", res);
  },
  toggleBottomBar: ({ commit }) => {
    commit("TOGGLEBOTTOMBAR");
  },
  toggleDarkTheme: ({ commit }) => {
    commit("TOGGLEDARKTHEME");
  },
  toggleNavbar: ({ commit }) => {
    commit("TOGGLENAVBAR");
  },
};

export default {
  state,
  mutations,
  actions,
};
